
export function needIndexComponent (chartComponent) {
  return !['text', 'richText', 'borderBlock', 'filterBlock', 'signName', 'timeClock'].includes(chartComponent)
}
